import React, { memo, useEffect } from "react";
import { useErrorHandler } from "react-error-boundary";
import { useHistory } from "react-router-dom";
import { config } from "../../config";
import { buildRouteWithParams } from "../../helpers/build-route-with-params";
import { commitPendingBooking } from "../../requests/pending-booking.requests";
import { bookingStore } from "../../stores/booking.store";
import { Booking } from "../../types";
import { Loader } from "../loader/loader";

const ConfirmationCommitPendingBooking = memo(() => {
  const throwError = useErrorHandler();
  const history = useHistory();
  useEffect(() => {
    const subscription = commitPendingBooking({}).subscribe((resp: Booking) => {
      bookingStore.booking = resp;
      history.push(buildRouteWithParams(config.routes.confirmationEnd));
      return () => {
        subscription.unsubscribe();
      };
    }, throwError);
  });
  return <Loader position={"fixed"} />;
});

export { ConfirmationCommitPendingBooking };
